import React from 'react';

/**
 * Generic segmented control [ A | B | C ].
 * Accent: Globe Insights purple (#5b3df0).
 *
 * Props:
 *  - value: currently selected option value
 *  - onChange: (value) => void
 *  - options: [{ value, label, icon?, dot? }]
 *  - size: 's' | 'm'
 */
const SegmentedControl = ({ value, onChange, options = [], size = 'm', className = '', disabled = false, disabledTitle }) => {
  const pad = size === 's' ? 'px-2 py-1.5 text-xs' : 'px-3.5 py-2 text-sm';

  return (
    <div
      className={`flex w-full bg-gray-100 dark:bg-gray-700/50 p-1 rounded-lg border border-gray-200 dark:border-gray-600 gap-0.5 ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${className}`}
      role="tablist"
      aria-disabled={disabled || undefined}
      title={disabled ? disabledTitle : undefined}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            tabIndex={disabled ? -1 : undefined}
            onClick={() => !disabled && onChange(opt.value)}
            className={`flex-1 inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-all duration-200 whitespace-nowrap outline-none ${pad} ${
              disabled ? 'cursor-not-allowed' : ''
            } ${
              active
                ? 'bg-white dark:bg-gray-600 shadow-sm text-[#5b3df0] dark:text-[#a98ff5]'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
            }`}
          >
            {opt.dot && (
              <span
                className="w-[7px] h-[7px] rounded-sm flex-shrink-0"
                style={{ background: opt.dot }}
                aria-hidden
              />
            )}
            {opt.icon}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
